import axios from "axios";
import { handleActions } from "redux-actions";

import Config from "config";
import { getHeaders } from "helpers/headers";
import { AnyAction } from "interfaces/action";
import { Dispatch } from "interfaces/dispatch";
import { ThunkActionCreator } from "interfaces/thunk";

// Updated interfaces to match API response
export interface StoreItem {
  store_id: number;
  store_name: string;
  retail_store_num: string;
}

export interface StateWithStores {
  state_name: string;
  stores: StoreItem[];
}

export interface ProjectStoresState {
  error: boolean;
  loading: boolean;
  content: StateWithStores[];
}

const FETCH_PROJECT_STORES_REQUEST = "FETCH_PROJECT_STORES_REQUEST";
const FETCH_PROJECT_STORES = "FETCH_PROJECT_STORES";
const FETCH_PROJECT_STORES_FAILED = "FETCH_PROJECT_STORES_FAILED";

export { FETCH_PROJECT_STORES_REQUEST, FETCH_PROJECT_STORES, FETCH_PROJECT_STORES_FAILED };

const fetchStoresByProjectId: ThunkActionCreator =
  (payload: { id: string }) => (dispatch: Dispatch) => {
    const { id } = payload;

    dispatch({ type: FETCH_PROJECT_STORES_REQUEST });

    return axios
      .get(`${Config.API_SERVICE_URL}/api/announcements/project-stores/${id}`, getHeaders())
      .then((response) => dispatch({ type: FETCH_PROJECT_STORES, payload: response.data }))
      .catch((error: Error) => {
        console.error("Error fetching project stores:", error);
        dispatch({ type: FETCH_PROJECT_STORES_FAILED });
      });
  };

export { fetchStoresByProjectId };

const initialState: ProjectStoresState = {
  loading: false,
  error: false,
  content: [],
};

const actions = {
  [FETCH_PROJECT_STORES_REQUEST]: (state: ProjectStoresState): ProjectStoresState => ({
    ...state,
    loading: true,
    error: false,
  }),

  [FETCH_PROJECT_STORES]: (state: ProjectStoresState, action: AnyAction): ProjectStoresState => ({
    ...state,
    loading: false,
    content: action.payload,
  }),

  [FETCH_PROJECT_STORES_FAILED]: (state: ProjectStoresState): ProjectStoresState => ({
    ...state,
    loading: false,
    error: true,
    content: [],
  }),
};

export default handleActions<ProjectStoresState, AnyAction>(actions, initialState);